// @generated by codegen v0.0.0 with parameter "target=ts,service.creativefabrica.vectorizer=NEXT_PUBLIC_RPC_VECTORIZER_URL,service.creativefabrica.social=NEXT_PUBLIC_RPC_SOCIAL_URL,service.creativefabrica.uploads=NEXT_PUBLIC_RPC_UPLOADS_URL,service.creativefabrica.studio=NEXT_PUBLIC_RPC_STUDIO_URL,include.creativefabrica.vectorizer.v2.VectorizerService.List=infiniteQuery,include.creativefabrica.social.v2.SocialService.GetUserFeaturedImages=query,include.creativefabrica.social.v2.SocialService.ListImageLibrary=query,include.creativefabrica.social.v2.SocialService.SelectFeaturedImages=mutation,include.creativefabrica.social.v2.SocialService.CreateSignedUrl=mutation,include.creativefabrica.social.v2.SocialService.PostProductProject=mutation,include.creativefabrica.social.v2.SocialService.ListAssets=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListMachines=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListMaterials=infiniteQuery,include.creativefabrica.social.v2.SocialService.ListThemes=infiniteQuery,include.creativefabrica.uploads.v2.UploadsService.CreateDirectVoDUploadUrl=mutation,include.creativefabrica.uploads.v2.UploadsService.InitiateVoDMultipartUpload=mutation,include.creativefabrica.uploads.v2.UploadsService.CompleteVoDMultipartUpload=mutation,include.creativefabrica.studio.v2.StudioService.GetUserBanStatus=query"
// @generated from file creativefabrica/social/v2/service.proto (package creativefabrica.social.v2, syntax proto3)
/* eslint-disable */

import type { InfiniteData, UseInfiniteQueryOptions, UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import { createConnectTransport } from "@connectrpc/connect-web";
import { createClient } from "@connectrpc/connect";
import type { MessageInitShape } from "@bufbuild/protobuf";

import invariant from 'tiny-invariant'

import { interceptors } from '@repo/rpc-codegen/interceptors'
import { createCallOptions } from '@repo/rpc-codegen/sensitive-call'

import { PostProductProjectResponse, PostProductProjectRequestSchema, ListMachinesResponse, ListMachinesRequestSchema, ListMaterialsResponse, ListMaterialsRequestSchema, ListThemesResponse, ListThemesRequestSchema, ListAssetsResponse, ListAssetsRequestSchema, CreateSignedUrlResponse, CreateSignedUrlRequestSchema, ListImageLibraryResponse, ListImageLibraryRequestSchema, SelectFeaturedImagesResponse, SelectFeaturedImagesRequestSchema, GetUserFeaturedImagesResponse, GetUserFeaturedImagesRequestSchema, SocialService } from "./service_pb";

/**
 * This file contains generated TanStack Query hooks for the gRPC services defined in service.proto
 */

/**
 * Base type for query keys. Query keys are arrays that uniquely identify a query,
 * consisting of a root key constant and optional variables.
 * @template TVariables - The type of variables that can be included in the query key
 */
type QueryKey<TVariables> = (TVariables | string)[];

/**
 * Base type for query options, containing the query key and query function.
 * @template TResult - The expected result type of the query
 * @template TVariables - The variables type for the query
 */
type QueryOptions<TResult, TVariables> = Pick<UseQueryOptions<TResult, Error, TResult, QueryKey<TVariables>>, 'queryKey' | 'queryFn'>;

/**
 * Hooks and utilities for the SocialService service
 * Service: creativefabrica.social.v2.SocialService
 */

invariant(process.env.NEXT_PUBLIC_RPC_SOCIAL_URL, 'NEXT_PUBLIC_RPC_SOCIAL_URL env var is not set within gen/service/creativefabrica/creativefabrica/social/v2/service_pb.ts. Please make sure the env var is available to your project/script/app.')

const SocialServiceTransport = createConnectTransport({
  baseUrl: process.env.NEXT_PUBLIC_RPC_SOCIAL_URL,
  useBinaryFormat: false,
  interceptors,
})

const SocialServiceClient = createClient(
  SocialService,
  SocialServiceTransport,
)

/**
 * Unique identifier for the PostProductProject mutation
 */
export const PostProductProjectMutationKey = 'SocialService.PostProductProject' as const;

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.PostProductProject
 */
/**
 * Function to execute the PostProductProject RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function postProductProjectFn(variables: MessageInitShape<typeof PostProductProjectRequestSchema>, meta?: Record<string, unknown>): Promise<PostProductProjectResponse> {
  return SocialServiceClient.postProductProject(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.social.v2.SocialService.PostProductProject
 */
export function usePostProductProjectMutation(options?: Omit<
  UseMutationOptions<
    PostProductProjectResponse,
    Error,
    MessageInitShape<typeof PostProductProjectRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    PostProductProjectResponse,
    Error,
    MessageInitShape<typeof PostProductProjectRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => postProductProjectFn(variables, options?.meta),
    mutationKey: [PostProductProjectMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ListMachines infinite query
 */
export const ListMachinesQueryRootKey = 'SocialService.ListMachines' as const;

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListMachines
 */
/**
 * Function to execute the ListMachines RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listMachinesFn(variables: MessageInitShape<typeof ListMachinesRequestSchema>, meta?: Record<string, unknown>) {
  return SocialServiceClient.listMachines(variables, createCallOptions(meta));
}

export function useListMachinesInfiniteQuery<D = ListMachinesResponse>(
  variables: MessageInitShape<typeof ListMachinesRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      ListMachinesResponse,
      Error,
      InfiniteData<D, string | undefined>,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [ListMachinesQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof ListMachinesRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return listMachinesFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListMachines
 */

/**
 * Unique identifier for the ListMaterials infinite query
 */
export const ListMaterialsQueryRootKey = 'SocialService.ListMaterials' as const;

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListMaterials
 */
/**
 * Function to execute the ListMaterials RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listMaterialsFn(variables: MessageInitShape<typeof ListMaterialsRequestSchema>, meta?: Record<string, unknown>) {
  return SocialServiceClient.listMaterials(variables, createCallOptions(meta));
}

export function useListMaterialsInfiniteQuery<D = ListMaterialsResponse>(
  variables: MessageInitShape<typeof ListMaterialsRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      ListMaterialsResponse,
      Error,
      InfiniteData<D, string | undefined>,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [ListMaterialsQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof ListMaterialsRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return listMaterialsFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListMaterials
 */

/**
 * Unique identifier for the ListThemes infinite query
 */
export const ListThemesQueryRootKey = 'SocialService.ListThemes' as const;

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListThemes
 */
/**
 * Function to execute the ListThemes RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listThemesFn(variables: MessageInitShape<typeof ListThemesRequestSchema>, meta?: Record<string, unknown>) {
  return SocialServiceClient.listThemes(variables, createCallOptions(meta));
}

export function useListThemesInfiniteQuery<D = ListThemesResponse>(
  variables: MessageInitShape<typeof ListThemesRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      ListThemesResponse,
      Error,
      InfiniteData<D, string | undefined>,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [ListThemesQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof ListThemesRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return listThemesFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListThemes
 */

/**
 * Unique identifier for the ListAssets infinite query
 */
export const ListAssetsQueryRootKey = 'SocialService.ListAssets' as const;

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListAssets
 */
/**
 * Function to execute the ListAssets RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listAssetsFn(variables: MessageInitShape<typeof ListAssetsRequestSchema>, meta?: Record<string, unknown>) {
  return SocialServiceClient.listAssets(variables, createCallOptions(meta));
}

export function useListAssetsInfiniteQuery<D = ListAssetsResponse>(
  variables: MessageInitShape<typeof ListAssetsRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      ListAssetsResponse,
      Error,
      InfiniteData<D, string | undefined>,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [ListAssetsQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof ListAssetsRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return listAssetsFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListAssets
 */

/**
 * Unique identifier for the CreateSignedUrl mutation
 */
export const CreateSignedUrlMutationKey = 'SocialService.CreateSignedUrl' as const;

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.CreateSignedUrl
 */
/**
 * Function to execute the CreateSignedUrl RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function createSignedUrlFn(variables: MessageInitShape<typeof CreateSignedUrlRequestSchema>, meta?: Record<string, unknown>): Promise<CreateSignedUrlResponse> {
  return SocialServiceClient.createSignedUrl(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.social.v2.SocialService.CreateSignedUrl
 */
export function useCreateSignedUrlMutation(options?: Omit<
  UseMutationOptions<
    CreateSignedUrlResponse,
    Error,
    MessageInitShape<typeof CreateSignedUrlRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    CreateSignedUrlResponse,
    Error,
    MessageInitShape<typeof CreateSignedUrlRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => createSignedUrlFn(variables, options?.meta),
    mutationKey: [CreateSignedUrlMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ListImageLibrary query
 */
export const ListImageLibraryQueryRootKey = 'SocialService.ListImageLibrary' as const;

/**
 * Return type for the ListImageLibrary query
 */
type ListImageLibraryQueryResult = ListImageLibraryResponse;

/**
 * Generates a unique query key for the ListImageLibrary query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `ListImageLibraryQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const listImageLibraryQueryKey = /*@__PURE__*/ function listImageLibraryQueryKey(variables?: MessageInitShape<typeof ListImageLibraryRequestSchema>): QueryKey<MessageInitShape<typeof ListImageLibraryRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof ListImageLibraryRequestSchema>> = [ListImageLibraryQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListImageLibrary
 */
/**
 * Function to execute the ListImageLibrary RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listImageLibraryFn(variables: MessageInitShape<typeof ListImageLibraryRequestSchema>, meta?: Record<string, unknown>): Promise<ListImageLibraryResponse> {
  return SocialServiceClient.listImageLibrary(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the ListImageLibrary query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = listImageLibraryQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useListImageLibraryQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const listImageLibraryQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof ListImageLibraryRequestSchema>): QueryOptions<ListImageLibraryQueryResult, MessageInitShape<typeof ListImageLibraryRequestSchema>> {
  return {
    queryKey: listImageLibraryQueryKey(variables),
    queryFn: async (context) => listImageLibraryFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.social.v2.SocialService.ListImageLibrary
 */
export function useListImageLibraryQuery<D = ListImageLibraryQueryResult, E = Error>(variables: MessageInitShape<typeof ListImageLibraryRequestSchema>, options?: Omit<
  UseQueryOptions<
    ListImageLibraryQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListImageLibraryRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    ListImageLibraryQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListImageLibraryRequestSchema>>
  >({
    ...options,
    ...listImageLibraryQueryOptions(variables),
  });
}

/**
 * Unique identifier for the SelectFeaturedImages mutation
 */
export const SelectFeaturedImagesMutationKey = 'SocialService.SelectFeaturedImages' as const;

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.SelectFeaturedImages
 */
/**
 * Function to execute the SelectFeaturedImages RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function selectFeaturedImagesFn(variables: MessageInitShape<typeof SelectFeaturedImagesRequestSchema>, meta?: Record<string, unknown>): Promise<SelectFeaturedImagesResponse> {
  return SocialServiceClient.selectFeaturedImages(variables, createCallOptions(meta));
}


/**
 * @generated from rpc creativefabrica.social.v2.SocialService.SelectFeaturedImages
 */
export function useSelectFeaturedImagesMutation(options?: Omit<
  UseMutationOptions<
    SelectFeaturedImagesResponse,
    Error,
    MessageInitShape<typeof SelectFeaturedImagesRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    SelectFeaturedImagesResponse,
    Error,
    MessageInitShape<typeof SelectFeaturedImagesRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => selectFeaturedImagesFn(variables, options?.meta),
    mutationKey: [SelectFeaturedImagesMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the GetUserFeaturedImages query
 */
export const GetUserFeaturedImagesQueryRootKey = 'SocialService.GetUserFeaturedImages' as const;

/**
 * Return type for the GetUserFeaturedImages query
 */
type GetUserFeaturedImagesQueryResult = GetUserFeaturedImagesResponse;

/**
 * Generates a unique query key for the GetUserFeaturedImages query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetUserFeaturedImagesQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getUserFeaturedImagesQueryKey = /*@__PURE__*/ function getUserFeaturedImagesQueryKey(variables?: MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>): QueryKey<MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>> = [GetUserFeaturedImagesQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * @generated from rpc creativefabrica.social.v2.SocialService.GetUserFeaturedImages
 */
/**
 * Function to execute the GetUserFeaturedImages RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getUserFeaturedImagesFn(variables: MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>, meta?: Record<string, unknown>): Promise<GetUserFeaturedImagesResponse> {
  return SocialServiceClient.getUserFeaturedImages(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetUserFeaturedImages query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getUserFeaturedImagesQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetUserFeaturedImagesQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getUserFeaturedImagesQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>): QueryOptions<GetUserFeaturedImagesQueryResult, MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>> {
  return {
    queryKey: getUserFeaturedImagesQueryKey(variables),
    queryFn: async (context) => getUserFeaturedImagesFn(variables, context.meta)
  };
};


/**
 * @generated from rpc creativefabrica.social.v2.SocialService.GetUserFeaturedImages
 */
export function useGetUserFeaturedImagesQuery<D = GetUserFeaturedImagesQueryResult, E = Error>(variables: MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetUserFeaturedImagesQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetUserFeaturedImagesQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetUserFeaturedImagesRequestSchema>>
  >({
    ...options,
    ...getUserFeaturedImagesQueryOptions(variables),
  });
}


